// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.School{
    width: 100%;  
    /*height: auto;*/
    background-color: e0f7fa;
margin-bottom: 0;
padding-bottom: 0;
}
.innerVision
{
    width: 80%;
    margin-left: 15%;
    text-align: left;
}
.mainHeading
{
    font-family: 'VanillaMilk';
    font-size: 50px;
    color: #8b0194;
    text-align: center;
    z-index: 1;
    padding: 20px;
}

.para
{
    font-family:'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    font-size:20px; 
    text-align: left;
    color: #8b0194; 

    z-index: 1; 
}
.classesModePics{
    display:flex;
    flex-direction: row;
    margin-left:15%;
}
.roadMapPic1,.roadMapPic2{
    width:40%;
    height:90vh;
}
.roadMapPic2{
    margin-left: 5%;
}
.roadMapContactButton
{
    display: flex;
    align-items: center;
    justify-content: center;
}
@media only screen and (max-width: 1000px)
{
    .classesModePics{
        flex-direction: column;
        margin-left: 0;        
    }
    .roadMapPic1,.roadMapPic2{
        width: 100%;
        height: auto;
        margin-left: 0;
    }

}`, "",{"version":3,"sources":["webpack://./src/MyComponents/FooterPages/PolymathKidSchool.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,gBAAgB;IAChB,wBAAwB;AAC5B,gBAAgB;AAChB,iBAAiB;AACjB;AACA;;IAEI,UAAU;IACV,gBAAgB;IAChB,gBAAgB;AACpB;AACA;;IAEI,0BAA0B;IAC1B,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,UAAU;IACV,aAAa;AACjB;;AAEA;;IAEI,2DAA2D;IAC3D,cAAc;IACd,gBAAgB;IAChB,cAAc;;IAEd,UAAU;AACd;AACA;IACI,YAAY;IACZ,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,SAAS;IACT,WAAW;AACf;AACA;IACI,eAAe;AACnB;AACA;;IAEI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;;IAEI;QACI,sBAAsB;QACtB,cAAc;IAClB;IACA;QACI,WAAW;QACX,YAAY;QACZ,cAAc;IAClB;;AAEJ","sourcesContent":[".School{\n    width: 100%;  \n    /*height: auto;*/\n    background-color: e0f7fa;\nmargin-bottom: 0;\npadding-bottom: 0;\n}\n.innerVision\n{\n    width: 80%;\n    margin-left: 15%;\n    text-align: left;\n}\n.mainHeading\n{\n    font-family: 'VanillaMilk';\n    font-size: 50px;\n    color: #8b0194;\n    text-align: center;\n    z-index: 1;\n    padding: 20px;\n}\n\n.para\n{\n    font-family:'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n    font-size:20px; \n    text-align: left;\n    color: #8b0194; \n\n    z-index: 1; \n}\n.classesModePics{\n    display:flex;\n    flex-direction: row;\n    margin-left:15%;\n}\n.roadMapPic1,.roadMapPic2{\n    width:40%;\n    height:90vh;\n}\n.roadMapPic2{\n    margin-left: 5%;\n}\n.roadMapContactButton\n{\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n@media only screen and (max-width: 1000px)\n{\n    .classesModePics{\n        flex-direction: column;\n        margin-left: 0;        \n    }\n    .roadMapPic1,.roadMapPic2{\n        width: 100%;\n        height: auto;\n        margin-left: 0;\n    }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
